import dayjs from 'dayjs';

export const REFRESH_TOKEN_CODE = 401;
export const FORBIDDEN_CODE = 403;
export const generateInvoiceType = {
  OIL_KITS_TYPE: 2,
  FREON_CYLINDER_TYPE: 1,
};

export const minDatePicker = dayjs('1990-01-01T00:00:00.000');
export const maxDatePicker = dayjs('2099-12-31T00:00:00.000');

export const vesselOrder = [
  'Condenser',
  'Evaporator',
  'Absorber',
  'Generator',
  'Heat Recovery',
  'Heat Exchanger',
];

export enum NavigationArrow {
  UP = 'up',
  DOWN = 'down',
  RIGHT = 'right',
  LEFT = 'left',
  NORTH = 'north',
  SOUTH = 'south',
  EAST = 'east',
  WEST = 'west',
  NORTH_EAST = 'northeast',
  NORTH_WEST = 'northwest',
  SOUTH_EAST = 'southeast',
  SOUTH_WEST = 'southwest',
}
